import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from './locales/en/translation.json';
import fiTranslation from './locales/fi/translation.json';
import svTranslation from './locales/sv/translation.json';
import { SUPPORTED_LANGUAGES, normalizeLanguage } from './utils/languages';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation
      },
      fi: {
        translation: fiTranslation
      },
      sv: {
        translation: svTranslation
      }
    },
    supportedLngs: SUPPORTED_LANGUAGES,
    fallbackLng: 'fi',
    lng: normalizeLanguage(localStorage.getItem('userLanguage')),
    ns: ['translation'],
    defaultNS: 'translation',
    debug: false,
    interpolation: {
      escapeValue: false
    }
  });

// Keep the <html lang> attribute in sync with the active UI language. Browsers
// (e.g. Chrome's auto-translate) use this attribute to detect the page language;
// if it stays "en" while the UI is Finnish, the browser may "translate" the
// Finnish text as if it were English, producing garbled results.
const applyHtmlLang = (lng) => {
  if (typeof document !== 'undefined' && lng) {
    document.documentElement.lang = lng;
  }
};

applyHtmlLang(i18n.language);
i18n.on('languageChanged', applyHtmlLang);

export default i18n;
